module.exports = __webpack_public_path__ + "static/media/node-management.b3fe8152.svg";